(function () {
  function trackScrollBannerClick(btn, banner) {
    if (!btn || !banner) return;

    // 🔒 Evita doppio tracking sullo stesso click
    if (btn.dataset.tracked === "1") return;
    btn.dataset.tracked = "1";

    const payload = {
      event: "app btn", // nome interno (con spazio) → GA4 "app_btn"
      banner_text:
        banner.dataset.bannerText ||
        banner.querySelector(".scroll-under-header-banner__text")?.textContent?.trim() ||
        "",
      link_url: btn.getAttribute("href") || "",
      page_path: window.location.pathname,
      page_location: window.location.href
    };

    // ✅ Tracking base: dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // Debug opzionale → ?debug_banner=1
    if (window.location.search.includes("debug_banner=1")) {
      console.log("[scroll-banner] quiz btn tracked", payload);
    }
  }

  function initScrollBanner(root = document) {
    const banner = root.querySelector("[data-scroll-banner]");
    if (!banner) return;

    if (banner.dataset.inited === "1") return;
    banner.dataset.inited = "1";

    const threshold = parseInt(banner.getAttribute("data-threshold") || "120", 10);

    // 👉 TRACK CLICK (una sola volta)
    const btn = banner.querySelector(".scroll-under-header-banner__btn");
    if (btn) {
      btn.addEventListener("click", () => {
        trackScrollBannerClick(btn, banner);
      });
    }

    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;

      if (y <= threshold) {
        banner.classList.remove("is-hidden");
        lastY = y;
        ticking = false;
        return;
      }

      const delta = y - lastY;
      if (Math.abs(delta) < 6) {
        ticking = false;
        return;
      }

      if (delta > 0) banner.classList.add("is-hidden");
      else banner.classList.remove("is-hidden");

      lastY = y;
      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
  }

  document.addEventListener("DOMContentLoaded", () => initScrollBanner(document));
  document.addEventListener("shopify:section:load", (e) => initScrollBanner(e.target));
})();
